module.exports = __webpack_public_path__ + "static/media/Roswell_8.643c71f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/Roswell_8.jpg
// module id = 500
// module chunks = 0